<template lang="pug">
  v-container.pa-0(style="max-width:600px")
    v-container.my-2.px-6.d-flex
      div.mr-2
        v-icon.mt-1(left color="black" :size="24" @click="$router.push('/admin/review/general-settings')") mdi-arrow-left
      div.title.font-weight-bold {{ $t('bills') }}
    //- Listing
    div.pa-0.main-container
      v-tabs(v-model="tab" fixed-tabs color="textColorAccent" height="40" slider-size="4" @change="checkTab")
        v-tab.button-AA-small.px-0 {{ $t('subscription') }}
        v-tab.button-AA-small.px-0 {{ $t('credit_history') }}
      div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")
      div
        v-tabs-items(v-model="tab" touchless)
          v-tab-item
            subscriptions(ref="subscriptions" :company="company")
          v-tab-item
            credit-history(ref="creditHistory" :company="company")
</template>

<script>
import { mapGetters } from 'vuex'
import Subscriptions from '@/components/settings/bills/Subscriptions.vue'
import CreditHistory from '@/components/settings/bills/CreditHistory.vue'

export default {
  name: 'BillsSettings',
  components: {
    Subscriptions,
    CreditHistory
  },
  data: () => ({
    tab: 0
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    })
  },
  mounted() {
    this.$route.hash ? this.checkHash() : this.checkTab()
  },
  methods: {
    back() {
      this.$router.replace({ query: null }).catch(() => {})
      this.$router.push('/admin/settings')
    },
    checkTab() {
      let hash
      let query = { page: 1 }
      switch (this.tab) {
        case 0:
          hash = '#subscription'
          if (this.$refs.subscriptions) {
            query = { page: this.$refs.subscriptions.page }
          }
          break

        case 1:
          hash = '#creditHistory'
          if (this.$refs.creditHistory) {
            query = { page: this.$refs.creditHistory.page }
          }
          break

        default:
          break
      }
      this.$router.replace({ hash, query }).catch(() => {})
    },
    checkHash() {
      switch (this.$route.hash) {
        case '#subscription' + this.$route.query.page ? `page=${this.$route.query.page}` : '':
          this.tab = 0
          break

        case '#creditHistory':
          this.tab = 1
          break

        default:
          this.tab = 0
          this.checkTab()
          break
      }
    },
    nextTab() {
      this.tab++
      this.checkTab()
    }
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height: 4px;
  top: 36px;
  left: 0px;
  right: 0px;
}
</style>
